export default __webpack_public_path__ + "static/media/jb-cosmetics.b9b77d50.svg";